import { render, staticRenderFns } from "./TutorForgot2.vue?vue&type=template&id=02e7ec7d&"
import script from "./TutorForgot2.vue?vue&type=script&lang=js&"
export * from "./TutorForgot2.vue?vue&type=script&lang=js&"
import style0 from "./TutorForgot2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports